import { render, staticRenderFns } from "./commentStats.vue?vue&type=template&id=71245066&scoped=true&"
import script from "./commentStats.vue?vue&type=script&lang=ts&"
export * from "./commentStats.vue?vue&type=script&lang=ts&"
import style0 from "./commentStats.vue?vue&type=style&index=0&id=71245066&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71245066",
  null
  
)

export default component.exports